import {Input as NewBaseInput} from '@esgi/ui-kit/control';
import {Input as NewControlInput} from '@esgi/ui-kit/form-control';

export const BaseInput = NewBaseInput;
export const TextInput = NewControlInput;
